import React from 'react';

import styled from 'styled-components';

export const Wrapper = styled.div<{ rounded?: boolean; small?: boolean }>`
  display: flex;
  overflow: hidden;
  white-space: pre;
  border-bottom: 1px solid var(--colorBlueGray200);
  position: relative;
  width: 100%;
  padding: ${({ small }) => (small ? '0 8px' : '0 16px')};
  border-radius: ${({ rounded }) => (rounded ? '8px' : '0')};
  background-color: var(--colorWhite);
`;

export const Item = styled.div<{ isSelected: boolean; small?: boolean }>`
  padding: ${({ small }) => (small ? '16px 8px' : '21px 12px')};
  font-size: ${({ small }) => (small ? '14px' : '16px')};
  font-weight: 600;
  cursor: pointer;
  color: ${({ isSelected }) =>
    isSelected ? 'var(--colorBlueGray1200)' : 'var(--colorBlueGray700)'};
  border-bottom: 3px solid transparent;
  border-color: ${({ isSelected }) => (isSelected ? ' var(--colorBlueGray1000)' : 'transparent')};
  user-select: none;
  height: ${({ small }) => (small ? '24px' : '64px')};
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  transition: border-color 0.2s ease-in-out, color 0.2s ease-in-out;

  &:hover {
    color: var(--colorBlueGray1200);
  }
`;
